
import { DataGridPro } from '@mui/x-data-grid-pro';
import { SubMenu } from './SubMenu';
import { useAccrualsData } from './hooks/useAccrualsData';
import { useCallback, useEffect } from 'react';
import { useTranslation } from 'react-i18next';


const AccrualCodesTable = () => {
    const { t } = useTranslation();

    const {
        rows,
        loadData,
        loading,
        selectedAccrualCode,
        setSelectedAccrualCode,
        contextMenu,
        setContextMenu,
        selected,
        setSelected,
        columns,
        cleanSelected
    } = useAccrualsData();


    const reloading = useCallback(() => {
        loadData();
    }, [loadData]);

    useEffect(() => {
        reloading();
    }, [reloading]);


    return (
        <div style={{ width: '100%', height: '100%'}}
            onContextMenu={(event) => {
                event.preventDefault();
                setContextMenu(contextMenu === null ? { mouseX: event.clientX + 2, mouseY: event.clientY - 6 } : null)
            }}
        >
            <DataGridPro
                sx={{ height: 'calc(100vh - 140px)' }}
                columns={columns}
                rows={rows}
                loading={loading}
                initialState={{
                    sorting: {
                        sortModel: [{ field: 'name', sort: 'asc' }],
                    },
                }}
                rowSelectionModel={selectedAccrualCode}
                pagination
                onRowSelectionModelChange={(newRowSelectionModel) => {
                    let row = rows.filter((row) => newRowSelectionModel.includes(row.id))
                    setSelectedAccrualCode(newRowSelectionModel);
                    setSelected(row);

                }}
                checkboxSelection
                localeText={
                    {
                        headerFilterOperatorContains: t('general.table.headerFilters.headerFilterOperatorContains'),
                        headerFilterOperatorEquals: t('general.table.headerFilters.headerFilterOperatorEquals'),
                        headerFilterOperatorStartsWith: t('general.table.headerFilters.headerFilterOperatorStartsWith'),
                        headerFilterOperatorEndsWith: t('general.table.headerFilters.headerFilterOperatorEndsWith'),
                        headerFilterOperatorIsEmpty: t('general.table.headerFilters.headerFilterOperatorIsEmpty'),
                        headerFilterOperatorIsNotEmpty: t('general.table.headerFilters.headerFilterOperatorIsNotEmpty'),
                        footerRowSelected: (count) =>
                            count > 1 ? `${t('general.table.footerFilters.footerRowSelected.>1', {count, countFormatted: count.toLocaleString()})} `
                                : `${t('general.table.footerFilters.footerRowSelected.=1', {count, countFormatted: count.toLocaleString()})}`,

                        footerTotalRows: t('general.table.footerFilters.footerTotalRows'),
                        MuiTablePagination: {
                            labelDisplayedRows: ({ from, to, count }) =>
                                `${from} - ${to} of ${count === -1 ? `more than ${to}` : count}`,
                            labelRowsPerPage: t('general.table.footerFilters.labelRowsPerPage'),
                        },
                    }
                }
                showCellVerticalBorder
                showColumnVerticalBorder
                disableColumnMenu
                headerFilters
                slotProps={{
                    toolbar: {
                        showQuickFilter: true,
                    }
                }}
            />
            <SubMenu
                selected={selected}
                cleanSelected={cleanSelected}
                rows={rows}
                contextMenu={contextMenu}
                setContextMenu={setContextMenu}
                reloading={reloading}
            />
        </div>
    );
}

export { AccrualCodesTable };